import { useTranslationInterface } from 'utils/hooks/useTranslation';

// strings for this module are in src/services/i18n/en-us/snippets.json

export const useTranslations = () => useTranslationInterface('snippets');
